import { isAppVersionAtLeast } from '@/utils';

//* 애드팝콘 SSP 광고 SDK·혜택탭 신규 기능 최소 요구 버전 — 미만이면 강제 업데이트
//! 스토어에 배포 완료된 버전만 올린다. forceUpdate 모달은 닫을 수 없어 미배포 버전을 넣으면 앱이 잠긴다.
const MIN_APP_VERSION = '3.2.0';

//* wello-app-container가 `welfarehello/<version> (<os>)`로 심는 UA 세그먼트.
const APP_VERSION_PATTERN = /welfarehello\/(\d+(?:\.\d+)*)/i;

//! 판정을 버전 브릿지 응답에 의존하지 않는다 — 응답 핸들러가 없는 구버전 앱은
//! 응답이 영원히 오지 않아 게이트가 침묵했다(fail-open). UA는 동기 출처다.
export const isForceUpdateRequired = (userAgent: string) => {
  const version = APP_VERSION_PATTERN.exec(userAgent)?.[1];

  //* 버전을 못 읽으면 미만으로 본다 — 버전 세그먼트 도입 전의 구버전 앱이다.
  return !version || !isAppVersionAtLeast(version, MIN_APP_VERSION);
};
